import type { ReactNode } from "react";
import { xmlTokenize } from "./tokenize";

export const XML_LINE_CAP = 5000;

export function XmlView({
  src,
  download,
}: {
  src: string;
  /** caller-supplied download link for the full document */
  download?: ReactNode;
}) {
  const lines = xmlTokenize(src);
  const shown = lines.slice(0, XML_LINE_CAP);
  const capped = lines.length > XML_LINE_CAP;
  return (
    <div className="xml">
      <pre className="code code-lines">
        {shown.map((line, i) => (
          <span className="l" key={i}>
            {line.tokens.map((t, j) => (
              <span className={`tk-${t.kind}`} key={j}>
                {t.text}
              </span>
            ))}
            {line.tokens.length === 0 ? " " : null}
          </span>
        ))}
      </pre>
      {capped ? (
        <div className="xml-note">
          Large document — showing first {XML_LINE_CAP} lines of {lines.length}. {download}
        </div>
      ) : null}
    </div>
  );
}

export { xmlTokenize } from "./tokenize";
export type { XmlLine, XmlToken, XmlTokenKind } from "./tokenize";
